import PortalIdParser from 'PortalIdParser';
import http from 'hub-http/clients/apiClient';
export const getEventDescription = eventTypeId => http.get(`events/internal/v0/app/event-types/${eventTypeId}?${`portalId=${PortalIdParser.get()}`}`).then(definition => definition.description);